import React, { useEffect } from 'react'

import { cn, getPaddingFromAspectRatio } from '../../lib/helpers'
import { videoAssetFor } from '../../lib/video-url'
import styles from './figure.module.css'

const VideoAnimation = ({ webm, fallback, aspectratio, alt, caption, shadow }) => {
  if (!webm || !fallback) {
    return null
  }
  const webmAsset = videoAssetFor(webm)
  const fallbackAsset = videoAssetFor(fallback)

  useEffect(() => {
    const loadLozad = async () => {
      const lozad = require('lozad')
      const observer = lozad()
      observer.observe()
    }

    loadLozad()
  })

  return (
    <figure
      className={styles.root}
      style={{ paddingTop: getPaddingFromAspectRatio(aspectratio) }}
    >
      <video
        title={alt}
        className={cn('lozad', shadow !== false ? styles.imageShadow : '')}
        loop muted autoPlay playsInline
      >
        <source data-src={webmAsset.url} type={`video/${webmAsset.extension}`} />
        <source data-src={fallbackAsset.url} type={`video/${fallbackAsset.extension}`} />
      </video>
      <figcaption className={styles.caption}>{caption}</figcaption>
    </figure>
  )
}

export default VideoAnimation
